<template>
  <form ref="form">
    <v-container grid-list-lg class="dialog-form-full-width">
      <v-layout align-start justify-space-between nowrap row mt-0 pt-0>
        <v-flex xs12 md12 lg12>
          <v-text-field
            v-model="customerNumber"
            label="Customer number"
            v-validate="'required'"
            :error-messages="errors.collect('customerNumber')"
            data-vv-name="customerNumber"
            data-vv-as="Customer number"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout align-start justify-space-between nowrap row>
        <v-flex xs12 md12 lg12>
          <v-select
            v-model="clientId"
            label="Client"
            v-validate="'required'"
            :items="clients"
            :error-messages="errors.collect('clientId')"
            data-vv-name="clientId"
            data-vv-as="Client"
            item-value="id"
            item-text="label"
          ></v-select>
          <!--<v-switch
            v-model="canAddShipTo"
            color="primary"
            label="Can add ShipTo"
          ></v-switch>-->
        </v-flex>
        <v-flex xs12>
          <v-select
            v-model="customization"
            label="Configuration"
            v-validate="'required'"
            :items="customizations"
            :error-messages="errors.collect('customization')"
            data-vv-name="customization"
            data-vv-as="Configuration"
            item-value="id"
            item-text="label"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-flex xs12>
        <v-btn @click="reset" class="ml-0">Clear</v-btn>
        <v-btn :loading="loading" @click="submit" type="submit" color="primary">
          Save
        </v-btn>
      </v-flex>
    </v-container>
  </form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  $_veeValidate: {
    validator: "new"
  },

  props: {
    customer: {
      type: Object,
      default: () => ({
        customerNumber: "",
        canAddShipTo: false,
        customization: "",
        clientId: null
      })
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      addCustomer: {}
    };
  },
  computed: {
    ...mapGetters("admin", {
      clients: "getClientList",
      customizations: "getCustomizationList"
    }),
    customerNumber: {
      get() {
        return this.addCustomer.customerNumber;
      },
      set(value) {
        this.$set(this.addCustomer, "customerNumber", value);
      }
    },
    canAddShipTo: {
      get() {
        return this.addCustomer.canAddShipTo;
      },
      set(value) {
        this.$set(this.addCustomer, "canAddShipTo", value);
      }
    },
    customization: {
      get() {
        return this.addCustomer.customization;
      },
      set(value) {
        this.$set(this.addCustomer, "customization", value);
      }
    },
    clientId: {
      get() {
        return this.addCustomer.clientId;
      },
      set(value) {
        this.$set(this.addCustomer, "clientId", value);
      }
    }
  },
  methods: {
    reset() {
      this.$refs.form.reset();
      this.$validator.reset();
      this.addCustomer = {};
    },
    submit(event) {
      event.preventDefault();
      this.$validator.validate().then(valid => {
        if (valid) {
          this.$emit("save", {
            number: this.customerNumber,
            canAddShipTo: this.canAddShipTo,
            customization: this.customization,
            clientId: this.clientId
          });
        }
      });
    }
  }
};
</script>
